import { useEffect, useState } from 'react'

function useGon() {
  const [gon, setGon] = useState(null)

  useEffect(() => {
    function setAndCheckGon() {
      if (window.gon) {
        setGon(window.gon)
      }
    }

    // Check if gon is already available
    if (window.gon && !gon) {
      setAndCheckGon()
    }

    // Listen for when gon becomes available
    window.addEventListener('window-config-loaded', setAndCheckGon)

    return () => {
      window.removeEventListener('window-config-loaded', setAndCheckGon)
    }
  }, [])

  return gon
}

export default useGon
